<template>
  <div class="pb-5">
    <section v-if="!loading && !error">
      <div class="content">
        <div class="row align-items-center">
          <div class="col-md-6">
            <Titulo
              :title="'Apresentação'"
              :description="'Visualize o vídeo abaixo e entenda o que podemos oferece'"
            />
          </div>
        </div>
        <div v-if="loadingLista" style="min-height: 50vh">
          <loading />
        </div>
        <div v-else class="mb-5">
          <div class="mt-4 text-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/8L_yOCbC6Zs"
              title="SPC Conciliador"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <div class="mt-3">
              <Botao
                title="Próximo"
                link="/produto/spc-conciliador/planos"
                nameClass="btn btn-warning font-weight-bold px-4"
                >SOLICITAR PRODUTO</Botao
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="loading">
      <loading />
    </section>
    <section v-if="error">
      <div
        class="card border-0 py-5 d-flex justify-content-center align-items-center mt-4"
      >
        <h5>{{ error }} 😟</h5>
      </div>
    </section>
    <div class="py-5"></div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";

export default {
  name: "ListaVidas",
  components: { Titulo, Botao },
  data() {
    return {
      produto: {
        nome: "SPC Conciliador",
        id: "Spcconciliador",
      },
      breadcrumb: [
        {
          nome: "SPC Conciliador",
          id: "SPC Conciliador",
          link: "/produto/spc-conciliador/painel",
        },
        {
          nome: "Institucional",
          id: "institucional",
          produto: "Apresentação do Produto",
        },
      ],
      reservas: [],
      registros: [],
      loading: true,
      error: null,
      qtdRegistros: 0,
      porPagina: 5,
      pagina: 1,
      loadingLista: false,
    };
  },
  methods: {
    consultaReservas() {
      this.reservas = [
        {
          info: {
            name: {
              label: "Espaço",
              value: "Sala de Reunião",
            },
            document: {
              label: "Evento",
              value: "Seminário XYZ",
            },
            responsavel: {
              label: "Responsável",
              value: "João da Silva Sauro",
            },
            plan: {
              label: "Intervalo de Uso",
              value: "25/06/2021 * 15:30-17:30",
            },
          },
        },
      ];
      this.loading = false;
      this.loadingLista = false;
      /*this.$http
        .get(
          `api/CdlBh/ConsultarSamVidaArta?linhas=${this.porPagina}&pagina=${this.pagina}`
        )
        .then((response) => {
          this.loading = false;
          this.loadingLista = false;
          this.registros = response.data.lista;
          this.qtdRegistros = response.data.totalLinhas;
          this.montarDados();
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.response.data.mensagem;
        });*/
    },
    selecionaPagina(pagina) {
      this.loadingLista = true;
      this.list = [];
      this.pagina = pagina;
      this.consultaVidas();
    },
    montarDados() {
      this.registros.forEach((el) => {
        var link = "";
        var label = "";
        var value = "";
        var descClass = "";
        var actionLink = true;
        var infoLabel = "";
        var external = false;
        if (el.cpF_DEPENDENTE === "") {
          if (el.status === "VIDA") {
            label = "Situação";
            value = "Ativa";
            link = "";
            descClass = "success";
          } else if (el.status == "TROCA ACOMODACAO") {
            label = "Troca de Acomodação";
            value = "Aguardando Pagamento";
            link = el.boletO_URL;
            external = true;
            descClass = "warning";
          } else if (el.status == "TROCA OPCIONAIS") {
            if (el.boletO_URL) {
              label = "Troca de Opcionais";
              value = "Aguardando Pagamento";
              link = el.boletO_URL;
              external = true;
              descClass = "warning";
            } else {
              label = "Troca de Opcionais";
              value = "Continuar processo";
              link = "";
              descClass = "warning";
            }
          } else {
            actionLink = false;
            if (el.linkdrive === "" && el.codchamado === "") {
              link = "/produto/cdl-saude-plano/documentos/" + el.cpF_TITULAR;
              label = "Documentação";
              value = "Clique para enviar";
              descClass = "warning";
            } else if (el.statuschamado === "Em Atendimento") {
              link = "/produto/cdl-saude-plano/documentos/" + el.cpF_TITULAR;
              label = "Documentação";
              value = "Em Análise";
              descClass = "success";
            } else if (el.statuschamado === "Reprovado") {
              link = "/produto/cdl-saude-plano/documentos/" + el.cpF_TITULAR;
              label = "Documentação";
              value = "Reprovado";
              descClass = "danger";
            } else if (
              el.statuschamado === "Aprovado" &&
              el.statuS_PAGARME == " "
            ) {
              link = "/produto/cdl-saude-plano/pagamento/" + el.cpF_TITULAR;
              label = "Pagamento";
              value = "Pendente";
              descClass = "warning";
            }
          }

          if (el.dependentes.length) {
            infoLabel = `Titular + ${el.dependentes.length} dependente(s)`;
          } else {
            infoLabel = "Titular";
          }

          const planValue = `${el.operadora}, ${el.assistencia} (${el.acomodacao})`;
          this.list.push({
            status: el.status,
            info: {
              name: {
                label: infoLabel,
                value: el.nome,
              },
              document: {
                label: "CPF",
                value: el.cpF_TITULAR,
              },
              plan: {
                label: "Plano",
                value: planValue,
              },
              status: {
                label: label,
                value: value,
                link: link,
                external: external,
                class: descClass,
              },
            },
            actions: [
              {
                label: "Alterar Plano",
                link: actionLink
                  ? "/produto/cdl-saude-plano/alterarPlano/" + el.cpF_TITULAR
                  : "",
                icon: "edit",
                disabled: el.status === "VIDA" ? false : true,
              },
            ],
          });
        }
      });
    },
    filtrarLista(filtro) {
      if (filtro === "PREVIDA") {
        return this.list.filter((el) => el.status === filtro);
      } else {
        return this.list.filter((el) => el.status !== "PREVIDA");
      }
    },
  },
  created() {
    localStorage.removeItem("cdlsaude_cadastro");
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.list = [];
    this.consultaReservas();
  },
};
</script>
